module.exports = __webpack_public_path__ + "img/poor-disabled.d44c485a.svg";